// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

// App Imports

import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {getDataPointUseByDataPointId} from "../DataPointClient";
import {changeDataPoint} from "../dataPointSlice";
import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";


// Main Function
export default function DataPointUseListDrawer({fetchDataPointUses}) {


    // ****************** BEGIN STATES ****************************

    const [dataPointUses, setDataPointUses] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const selectorDataPointId = useSelector((state) => state.dataPointSlc.value.dpuListId);
    const selectorDpuDrawerState = useSelector((state) => state.dataPointSlc.value.dpuListDrawerState);
    const displayId = useSelector((state) => state.dataPointSlc.value.id);
    const displayName = useSelector((state) => state.dataPointSlc.value.name);

    // ********************** END STORE ********************************


    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const dispatchData = useDispatch();


    // ****************** BEGIN FETCH ****************************

    const fetchDataPointUseList = () =>
        getDataPointUseByDataPointId(selectorDataPointId)
            .then(data => {
                console.log("this as my response");
                console.log(data);
                setDataPointUses(data);
            });


    useEffect(() => {
        fetchDataPointUseList();
    }, [ useSelector((state) => state.dataPointSlc.value.dpuListDrawerState)===true]);

    // ****************** END FETCH ****************************


    const renderDataPointUses = dataPointUses => {
        if (dataPointUses.length <= 0) {
            return "No Data";
        }}

    // ****************** BEGIN CRUD ***********************************

    // ****************** END CRUD ***********************************

    function closeDataPointUseListDrawer() {
        dispatchData(changeDataPoint({dpuListId: 0, dpuListDrawerState: false}));
    };


    // ****************** BEGIN DRILLDOWN ****************************

    // ****************** END DRILLDOWN ****************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = fetchDataPointUses => [

        {    field: 'id',
            headerName: 'ID',
            sortable: true,
            width: 80,
        },
        {    field: 'dataSet',
            headerName: 'Data Set',
            sortable: true,
            width: 100,
        },
        {    field: 'contractType',
            headerName: 'Type',
            sortable: true,
            width: 130,
        },
        {    field: 'contractCategory',
            headerName: 'Category',
            sortable: true,
            width: 250,
        },
        {    field: 'contractName',
            headerName: 'Contract',
            sortable: true,
            width: 300,
        },
        {    field: 'sectionName',
            headerName: 'Section',
            sortable: true,
            width:500,
        },
        {    field: 'sectionOrdinalNumber',
            headerName: 'Order',
            sortable: true,
            width: 80,
        },
        {    field: 'contractLevel',
            headerName: 'Level',
            sortable: true,
            width: 100,
        },
        {    field: 'destinationFolder',
            headerName: 'Folder',
            sortable: true,
            width: 130,
        },

    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1700 },
                }}
                anchor='right'
                open={selectorDpuDrawerState}
                initialState={{open: false}}
                onClose={closeDataPointUseListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                <h1 onClick={() => closeDataPointUseListDrawer()} >Data Point Uses</h1>
                    <Stack direction="row" spacing={1}>
                        <Typography component="span">id:</Typography>
                        <Typography component="span" fontWeight="bold">{displayId}</Typography>
                        <Box sx={{ ml: 6 }} /> {/* Adds extra spacing before 'name:' */}
                        <Typography component="span">name:</Typography>
                        <Typography component="span" fontWeight="bold">{displayName}</Typography>
                    </Stack>
                </Box>
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"DataPointUses"}
                    rows={dataPointUses}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(fetchDataPointUseList)}
                    density={"compact"}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    rowKey={dataPointUse => dataPointUse.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
